import React from "react";
import {
  Container,
  CssBaseline,
  Typography,
} from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

import Header from './Header';
import Footer from './Footer';
import Copyright from "../../../Components/Advertisers/Copyright";
import { useStyles } from './styles';
import Logo from '../../../Assets/--WhiteBluePNG-TM.png';

const BaseAuth = ({title, children}) => {
  const classes = useStyles();

  return (
    <div className="mainBG">
      <Header />
      <img alt='FocusLoop' src={Logo} className={classes.logo} />
      <Typography component="h1" variant="h4" style={{ color: 'white', marginBottom: '20px', textAlign: 'center' }}>
        {title}
      </Typography>
      <Container
        component="main"
        maxWidth="xs"
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          alignItems: 'center',
          paddingBottom: 64,
        }}
      >
        <CssBaseline />
        <div className={classes.paper}>
          {children}
        </div>
      </Container>
      <Footer />
    </div>
  )
};

export default BaseAuth;
